import React from 'react'

interface WizardInputProps {
  label: string
  required?: boolean
  placeholder?: string
  value: string
  onChange: (value: string) => void
}

const WizardInput = ({ label, required, placeholder, value, onChange }: WizardInputProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    <label style={{ fontSize: '0.875rem', fontWeight: 600, color: '#0a0d47' }}>
      {label}{required && <span style={{ color: '#ef4444', marginLeft: '2px' }}>*</span>}
    </label>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={{
        padding: '10px 14px',
        borderRadius: '8px',
        border: '1.5px solid #e5e7eb',
        fontSize: '0.875rem',
        color: '#374151',
        outline: 'none',
        width: '100%',
        boxSizing: 'border-box',
      }}
    />
  </div>
)

export default WizardInput
